import DashboardIcon from "@mui/icons-material/Dashboard";
import FolderIcon from "@mui/icons-material/Folder";
import TuneIcon from "@mui/icons-material/Tune";
import FlagIcon from "@mui/icons-material/Flag";
import SettingsIcon from "@mui/icons-material/Settings";
import type { SvgIconComponent } from "@mui/icons-material";

export const DRAWER_WIDTH = 256;

export interface NavItem {
  path: string;
  i18nKey: string;
  icon: SvgIconComponent;
  requiresAuth: boolean;
  section?: string;
}

export const NAV_ITEMS: NavItem[] = [
  {
    path: "/dashboard",
    i18nKey: "nav.dashboard",
    icon: DashboardIcon,
    requiresAuth: true,
    section: "MAIN MENU",
  },
  {
    path: "/projects",
    i18nKey: "nav.projects",
    icon: FolderIcon,
    requiresAuth: true,
  },
  {
    path: "/properties",
    i18nKey: "nav.properties",
    icon: TuneIcon,
    requiresAuth: true,
  },
  {
    path: "/flags",
    i18nKey: "nav.flags",
    icon: FlagIcon,
    requiresAuth: true,
  },
  {
    path: "/account",
    i18nKey: "nav.account",
    icon: SettingsIcon,
    requiresAuth: true,
    section: "SETTINGS",
  },
];
